// [ZL] This file forces the polyfill of features that are required by vendor (node_modules)
// code but has not been polyfilled by that vendor
import 'core-js/es6/number.js';
import 'core-js/es6/set.js';
import 'core-js/es6/symbol.js';
import 'core-js/es6/weak-map.js';
import 'core-js/es7/map.js';
import 'core-js/es7/object.js';
import 'core-js/es7/promise.js';
import 'core-js/fn/array/fill.js';
import 'core-js/fn/array/find.js';
import 'core-js/fn/array/find-index.js';
import 'core-js/fn/array/from.js';
import 'core-js/fn/array/includes.js';
import 'core-js/fn/promise/index.js';
import 'core-js/fn/object/get-own-property-descriptors.js';
import 'core-js/fn/string/ends-with.js';
import 'core-js/fn/string/includes.js';
import 'core-js/fn/string/starts-with.js';
import 'core-js/fn/string/trim-left.js';
import 'core-js/fn/string/trim-right.js';
import setPrototypeOf from 'setprototypeof';

Object.setPrototypeOf = setPrototypeOf;

// Adapted from https://gist.github.com/paulirish/1579671
(() => {
  let lastTime = 0;
  const vendors = ['ms', 'moz', 'webkit', 'o'];

  if (!window.requestAnimationFrame) {
    vendors.forEach(vendor => {
      window.requestAnimationFrame = window[`${vendor}RequestAnimationFrame`];
      window.cancelAnimationFrame =
        window[`${vendor}CancelAnimationFrame`] || window[`${vendor}CancelRequestAnimationFrame`];
    });
    window.requestAnimationFrame = callback => {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = id => {
      clearTimeout(id);
    };
  }
})();
